import "./device-frames.css";

/**
 * LaptopFrame — CSS-only MacBook-style chassis.
 * Renders `children` inside the screen area at a fixed 16:10 aspect ratio.
 * The frame collapses gracefully to a fluid min-height on narrow viewports.
 */
export function LaptopFrame({ children, caption = null, className = "" }) {
    return (
        <div className={`md-laptop ${className}`} data-testid="device-frame-laptop">
            <div className="md-laptop-lid">
                <div className="md-laptop-screen">
                    {children}
                </div>
            </div>
            <div className="md-laptop-base" aria-hidden="true" />
            {caption && <span className="md-frame-caption">{caption}</span>}
        </div>
    );
}

/**
 * PhoneFrame — CSS-only iPhone-style chassis with notch, home indicator,
 * and side buttons. Content is rendered inside a scrollable screen area.
 *
 * variant="media" enlarges the chassis and removes inner padding so real
 * product screenshots or nested UI mockups fill the screen edge-to-edge.
 */
export function PhoneFrame({ children, caption = null, className = "", variant = null }) {
    const variantCls = variant === "media" ? "md-phone--media" : "";
    return (
        <div className={`md-phone ${variantCls} ${className}`.trim()} data-testid="device-frame-phone">
            <div className="md-phone-shell">
                <span className="md-phone-side vol-up" />
                <span className="md-phone-side vol-dn" />
                <span className="md-phone-side pwr" />
                <span className="md-phone-notch" />
                <div className="md-phone-screen">
                    {children}
                </div>
                <span className="md-phone-home" aria-hidden="true" />
            </div>
            {caption && <span className="md-frame-caption">{caption}</span>}
        </div>
    );
}
